import { render, staticRenderFns } from "./wechatBindingIndex.vue?vue&type=template&id=0fc8e85b&"
import script from "./wechatBindingIndex.vue?vue&type=script&lang=js&"
export * from "./wechatBindingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports